<template>
    <div class="pp-info-box-chat">
        <input type="text" :placeholder="text.type_your_message_here" v-model="txt">
        <button @click="sendMessage">{{word.chat_now}}</button>
    </div>
</template>

<script>
    export default {
        name: "start-chat",

        props: [
            'userId'
        ],

        data() {
            return {
                txt: '',
                word: window.word,
                text: window.text,
            };
        },

        methods: {
            sendMessage() {
                axios.post('/api/v1/chat', {user_id: this.userId, text: this.txt},{params : {token : window.jwt_token}})
                    .then(response => {
                        if (response.status === 201) {
                            this.$toast.success(this.text.your_request_has_been_sent_successfully);
                        }

                        if (response.status === 200) {
                            this.$toast.warning(this.text.you_cant_send_two_request_to_the_same_person);
                        }
                    })
                    .catch(error => {
                        // TODO handle canFeatureValidation error
                        if (error.response.status === 422) {
                            this.$toast.error(this.text.please_fill_message_field);
                        }

                        if (error.response.status === 400) {
                            this.$toast.error(this.word.blocked);
                        }
                    });
            },
        },
    }
</script>
